<div
  class="cb-battle-middle-results-player"
  [class.winner]="isWinner()"
  [class.loser]="!isWinner()"
  [class.is-one-vs-one]="battle().max_participants === 2"
>
  <div
    class="cb-battle-middle-results-player--particles flex items-center justify-center"
  >
    <ngx-particles
      [id]="slot() + '-results-particles'"
      [options]="particlesOptions"
    ></ngx-particles>
  </div>

  <div class="cb-battle-middle-results-player--result typography-title">
    {{ isWinner() ? "Winner" : "Loser" }}
  </div>
  <div class="cb-battle-middle-results-player--values">
    <div class="cb-battle-middle-results-player--value show">
      <span class="cb-battle-middle-results-player--value__text"> Drops: </span>
      <app-balance-icon
        [balance]="player()?.balance ?? 'skins'"
        [color]="isWinner() ? 'var(--green)' : 'var(--red)'"
      ></app-balance-icon>
      <number-flow style="color: currentColor" #totalDropsRef></number-flow>
    </div>
    <div
      [class.show]="isShowEarned()"
      [class.hidden]="!isShowEarned()"
      class="cb-battle-middle-results-player--value"
    >
      <span class="cb-battle-middle-results-player--value__text"> Earned: </span>
      <app-balance-icon
        [balance]="player()?.balance ?? 'skins'"
        [color]="isWinner() ? 'var(--green)' : 'var(--red)'"
      ></app-balance-icon>
      <number-flow style="color: currentColor" #totalEarnedRef></number-flow>
    </div>
  </div>
</div>
